import { MenuItem, Tooltip, Typography } from '@mui/material';
import { Lock } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import type { ProfileMenuItem } from './profileMenuConfig';

type ProfileMenuItemRowProps = {
  item: ProfileMenuItem;
  selected: boolean;
  onNavigate: () => void;
};

export const ProfileMenuItemRow: React.FC<ProfileMenuItemRowProps> = ({
  item,
  selected,
  onNavigate,
}) => {
  const { t } = useTranslation();
  const { Icon } = item;
  const label = t(item.labelKey);
  const lockedTooltip = t('packageFeatures.lockedTooltip');
  const locked = item.locked === true;
  const menuItem = (
    <MenuItem
      component={Link}
      to={locked && item.feature ? `/subscription?feature=${item.feature}` : item.path}
      onClick={onNavigate}
      selected={selected}
      aria-label={locked ? `${label} – ${lockedTooltip}` : label}
      className="gap-3 px-4 py-2.5 text-gray-700 hover:bg-gray-100 dark:text-slate-300 dark:hover:bg-slate-700"
    >
      <Icon size={18} className="text-gray-500 dark:text-slate-400" />
      <Typography
        variant="body2"
        className={locked ? 'text-gray-500 dark:text-slate-500' : undefined}
      >
        {label}
      </Typography>
      {locked && <Lock size={14} className="ml-auto text-gray-400 dark:text-slate-500" />}
    </MenuItem>
  );

  if (!locked) return menuItem;

  return (
    <Tooltip title={lockedTooltip} placement="left" arrow>
      {menuItem}
    </Tooltip>
  );
};
